import React from 'react';
import REST from 'go/requests/rest';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {Segment, Header, Dropdown, Confirm, Message, Pagination} from 'semantic-ui-react';
import _ from 'lodash';
import {withRouter} from 'react-router-dom';
import produce from 'immer';
import {compileContent} from 'common/utils';
import {shouldDisplay} from 'componentLibrary/layout/ShowHide';
import {isAOorSAOorGMS} from 'go/security/permissions';
import {STATUS_PENDING_SUBMISSION} from 'app-ui-componentlibrary/dist/common/constants';
export class DynamicEntityList extends React.Component {
  state = {};

  componentDidMount() {
    const {data, orderBy} = this.props;
    this.setState({
      data: _.orderBy(
        _.omit(data, 'loading'),
        _.map(orderBy, (order) => order.key),
        _.map(orderBy, (order) => order.order || '')
      ),
    });
  }
  componentDidUpdate(prevProps) {
    const {data, orderBy} = this.props;
    if (!_.isEqual(data, prevProps.data)) {
      this.setState({
        data: _.orderBy(
          _.omit(data, 'loading'),
          _.map(orderBy, (order) => order.key),
          _.map(orderBy, (order) => order.order || '')
        ),
      });
    }
  }

  filterEntities = (entities, filterByInput, filterPath) => {
    if (!_.isEmpty(filterByInput) && filterPath !== undefined) {
      const filteredEntities = _.filter(entities, (entity) => {
        let parentEntityId = _.get(entity, filterPath);
        return _.isEqual(parentEntityId, filterByInput);
      });
      return filteredEntities;
    } else {
      return entities;
    }
  };

  show = () => this.setState({confirmOpen: true, value: ''});
  handleConfirm = () => {
    let withdrawMessage = '';
    const {selectedEntity} = this.state;
    const {entityDataPath, data} = this.props;
    const dataArray = _.values(_.omit(data, 'loading'));
    const entity = produce(selectedEntity, (draft) => {
      draft.status = 'withdrawn';
    });
    REST.dynamicData
      .updateEntity(this.props.token, entity)
      .then(REST.handler.handleResponse)
      .then(() => {
        let index = _.findIndex(
          dataArray,
          (result) => result.entityNumber === entity.entityNumber
        );
        const dataPathIndex = entityDataPath + `[${index}]`;
        this.props.saveEntitySessionData(dataPathIndex, entity);
        this.setState({
          confirmOpen: false,
          openMessage: true,
          message: withdrawMessage,
        });
      });
  };
  handleCancel = () => this.setState({confirmOpen: false});
  doEntityAction(value, row, taskId) {
    const {actionEntityType, actionEntityIdKey} = this.props;
    const entityType = actionEntityType ? actionEntityType : row.entityType;
    const entityId = _.get(row, actionEntityIdKey, row.entityId);
    switch (value) {
      case 'entityView':
        this.props.history.push(`/${entityType}/${entityId}/view`);
        break;
      case 'entityEdit':
        this.props.history.push(`/${entityType}/${entityId}/edit`);
        break;
      case 'task':
        this.props.history.push(`/tasks/${taskId}`);
        break;
      case 'withdraw':
        this.setState({selectedEntity: row}, () => this.show());
        break;
      default:
    }
  }
  renderEntityActions = ({row, entityDataPath, actions, taskId}) => {
    const {
      saveEntitySessionData,
      token,
      history,
      actionEntityType,
      actionEntityIdKey,
    } = this.props;
    const {confirmOpen, value} = this.state;
    let withdrawMessage = '';
    let finalActions = [];
    _.forEach(actions, (action) => {
      if (
        shouldDisplay(undefined, undefined, action.shouldDisplayRules, {
          row,
          shouldDisplayIfAnyRules: action.shouldDisplayIfAnyRules,
          ...this.props,
        })
      ) {
        finalActions.push({
          key: action.key,
          text: action.text,
          value: action.value,
        });
        if (action.value === 'withdraw') {
          withdrawMessage = action.message;
        }
      }
    });
    const entityId = _.get(row, actionEntityIdKey, row.entityId);
    const entityType = actionEntityType ? actionEntityType : row.entityType;
    return [
      withdrawMessage === '' ? null : (
        <Confirm
          open={confirmOpen}
          cancelButton="No"
          confirmButton="Yes"
          content="Are you sure you want to withdraw your request?"
          onCancel={this.handleCancel}
          onConfirm={this.handleConfirm}
          key={'withdraw-confirm'}
        />
      ),
      <Dropdown
        direction="left"
        selectOnNavigation={false}
        selectOnBlur={false}
        text={'Actions'}
        name={`${entityId}-action-button`}
        id={`${entityId}-action-button`}
        key={`${entityId}-action-button`}
        value={value}
        onChange={(e, {name, value}) => this.doEntityAction(value, row, taskId)}
        options={finalActions}
      />,
    ];
  };

  renderTable = (data) => {
    const {columns, entityDataPath, header} = this.props;
    const keys = _.keys(columns);
    const tableCell = (child, key) => (
      <FemaGoTable.TextCell key={key}>{child}</FemaGoTable.TextCell>
    );
    return (
      <FemaGoTable columns={_.size(keys)} withForm={false} summary={header}>
        <FemaGoTable.Header>
          <FemaGoTable.Row key="entityListHeaderTable">
            {_.map(keys, (k) => (
              <FemaGoTable.HeaderCell key={k + ' header'}>{k}</FemaGoTable.HeaderCell>
            ))}
          </FemaGoTable.Row>
        </FemaGoTable.Header>
        <FemaGoTable.Body>
          {_.map(data, (row, i) => (
            <FemaGoTable.Row key={i}>
              {_.map(keys, (k, j) => {
                const curr = columns[k];
                switch (k) {
                  case 'Action':
                    let actionProps = _.transform(
                      curr.props,
                      (p, v, k) => (p[k] = compileContent(v, {row, ...this.props}))
                    );
                    return tableCell(
                      this.renderEntityActions({
                        row,
                        entityDataPath: `${entityDataPath}.${i}`,
                        actions: curr.actions,
                        ...actionProps,
                        ...this.props,
                      }),
                      j
                    );
                  default:
                    return tableCell(compileContent(curr, {row, ...this.props}, true), j);
                }
              })}
            </FemaGoTable.Row>
          ))}
        </FemaGoTable.Body>
      </FemaGoTable>
    );
  };

  render() {
    const {header, headerSize, pageSize, filterByInput, filterPath} = this.props;
    const {activePage = 1, data, openMessage = false, message} = this.state;
    const dataToRender = _.slice(
      data,
      (activePage - 1) * pageSize,
      activePage * pageSize
    );

    const filteredData = this.filterEntities(dataToRender, filterByInput, filterPath);
    return (
      <Segment>
        {openMessage ? (
          <Message
            success
            header="Success"
            content={message}
            onDismiss={() => this.setState({openMessage: false})}
          />
        ) : null}
        <Header as={headerSize || 'h4'} content={header} id={header} />
        {this.renderTable(filteredData)}
        {(_.isArray(data) && _.size(data)) > pageSize ? (
          <div className="pagination-wrapper pagination">
            <Pagination
              totalPages={Math.ceil(_.size(data) / pageSize)}
              activePage={activePage}
              onPageChange={(e, data) => this.setState({activePage: data.activePage})}
            />
          </div>
        ) : (
          ''
        )}
      </Segment>
    );
  }
}

export default withRouter(connectDynamic(DynamicEntityList));
